import React from 'react';
import { Wallet, Shield, Smartphone, Download } from 'lucide-react';

const wallets = [
  {
    name: 'BlueWallet',
    type: 'Mobile',
    features: ['Beginner-friendly', 'Open source', 'Built-in exchange'],
    link: 'https://bluewallet.io'
  },
  {
    name: 'Exodus',
    type: 'Desktop/Mobile',
    features: ['Multi-currency', 'Built-in exchange', '24/7 support'],
    link: 'https://exodus.com'
  }
];

export default function WalletGuide() {
  return (
    <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-8">
      <h2 className="text-3xl font-bold text-white mb-6">Recommended Wallets</h2>
      <p className="text-gray-300 mb-8">
        Choose a secure wallet to store your Bitcoin. We recommend these trusted options:
      </p>
      <div className="grid md:grid-cols-2 gap-6">
        {wallets.map((wallet, index) => (
          <div key={index} className="bg-gray-700/50 rounded-lg p-6">
            <h3 className="text-xl font-semibold text-white mb-2">{wallet.name}</h3>
            <p className="text-purple-400 mb-4">{wallet.type}</p>
            <ul className="space-y-2 mb-4">
              {wallet.features.map((feature, i) => (
                <li key={i} className="flex items-center text-gray-300">
                  <Shield className="w-4 h-4 text-purple-500 mr-2" />
                  {feature}
                </li>
              ))}
            </ul>
            <a
              href={wallet.link}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-2 text-purple-400 hover:text-purple-300"
            >
              <Download className="w-4 h-4" />
              <span>Download</span>
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}